import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { authAction} from '../hooks/actions/mainAction'
import { menuAction } from 'hooks/actions/etcAction'
import { Button } from 'antd'

function Auth () {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // console.log("이거 실행?")
  dispatch(authAction(false, null))
  dispatch(menuAction(null, null))

  const toLogin = () => {
    dispatch(authAction(false, null))
    dispatch(menuAction(null, null))
    navigate("/login")
  }

  return (
    <div>
        <div>
            인증이 만료되었습니다. 다시 로그인 해주세요.
        </div>
        <Button onClick={toLogin}>다시 로그인하러 가기</Button>
    </div>
  )
}

export default Auth